// @flow
import React from 'react';

import Modal, { ModalHeader } from 'app/common/components/Modal';
import Button, { ButtonsBar } from 'app/common/ui/Button';

import CartItem from '../OrderList/CartItem';
import styles from './Add2CartModal.module.scss';;


type Props = {
  onClose: (e: SyntheticEvent<HTMLElement>) => void,
  productId: number,
  onDeleteProduct?: (void) => void,
}

const Add2CartModal = ({ onClose, productId, onDeleteProduct }: Props) => (
  <Modal close={onClose} isOpen className={styles.root}>
    <ModalHeader>{'Товар добавлен в корзину'}</ModalHeader>
    <CartItem
      className={styles.cartItem}
      productId={productId}
      onDeleteProduct={onDeleteProduct}
    />
    <ButtonsBar middle className={styles.buttons}>
      <Button onClick={onClose} outline>{'Продолжить покупки'}</Button>
      <Button href="/shop/cart">{'Перейти в корзину'}</Button>
    </ButtonsBar>
  </Modal>
);

export default Add2CartModal;
